import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { TariffDirection } from '../../../api/Optimise';
import { AppContext } from '../../../context/AppContext';
import EnergyIcon from '../../EnergyIcon';
import SmartTariffWarning from '../../SmartTariffWarning';
import { StyledH3, StyledHr, StyledSemiboldLabel } from '../../Styled';

import InformationPanel from './InformationPanel';

const TariffInformation = () => {
  const navigate = useNavigate();
  const { userDetails } = useContext(AppContext);
  const isLoadingUserDetails = !userDetails;

  return (
    <>
      {!userDetails?.has_smart_tariff && !isLoadingUserDetails && (
        <>
          <StyledH3 className="d-flex justify-content-between mt-4">
            <span>{'Tariff information'}</span>{' '}
          </StyledH3>
          <SmartTariffWarning
            linkText="Open tariff recommender."
            linkAction={() => {
              navigate(`/app/tariffs`);
            }}
            styleOverride={{ marginTop: 0 }}
          />
        </>
      )}
      {userDetails?.has_smart_tariff && !isLoadingUserDetails && (
        <InformationPanel
          title="Tariff information"
          isLoading={!userDetails?.tariffs}
          loadingLines={4}
          onEdit={() => navigate('/edit/tariff')}
        >
          <div className="d-flex align-items-center">
            <EnergyIcon direction={TariffDirection.IMPORT} />
            <div className="pl-2">
              <li>
                <StyledSemiboldLabel>Import energy provider:</StyledSemiboldLabel>{' '}
                {userDetails?.tariffs.import_tariff.supplier}
              </li>
              <li>
                <StyledSemiboldLabel>Import tariff:</StyledSemiboldLabel>{' '}
                {userDetails?.tariffs.import_tariff.tariff_name}
              </li>
            </div>
          </div>
          <StyledHr />
          <div className="d-flex align-items-center">
            <EnergyIcon direction={TariffDirection.EXPORT} />
            <div className="pl-2">
              <li>
                <StyledSemiboldLabel>Export energy provider:</StyledSemiboldLabel>{' '}
                {userDetails?.tariffs.export_tariff.supplier}
              </li>
              <li>
                <StyledSemiboldLabel>Export tariff:</StyledSemiboldLabel>{' '}
                {userDetails?.tariffs.export_tariff.tariff_name}
              </li>
            </div>
          </div>
        </InformationPanel>
      )}
    </>
  );
};

export default TariffInformation;
